import { create } from "zustand";

/**
 * Yakalama moduna girerken saklanan cevap taslağı. Kullanıcı ekran
 * görüntüsü almak için başka bir sayfaya gittiğinde composer unmount
 * olacağı için yazdıkları burada bekletilir.
 */
export interface CaptureDraft {
  body: string;
}

interface ScreenshotCaptureStore {
  /** Yakalama modu aktifken uygulamanın üstünde kontrol çubuğu görünür */
  isCapturing: boolean;
  /** Yakalama bitince geri dönülecek adres (pathname + search) */
  returnTo: string | null;
  /** Moda girilirken saklanan taslak; dönüşte composer'a iade edilir */
  draft: CaptureDraft | null;
  /** Yakalanan görsel; composer tüketene kadar burada bekler */
  pendingFile: File | null;

  startCapture: (options: { returnTo: string; draft?: CaptureDraft }) => void;
  cancelCapture: () => void;
  finishCapture: (file: File) => void;
  /** Bekleyen görseli ve taslağı tek seferlik okur, ardından temizler */
  consumeCapture: () => { file: File; draft: CaptureDraft | null } | null;
}

export const useScreenshotCaptureStore = create<ScreenshotCaptureStore>()(
  (set, get) => ({
    isCapturing: false,
    returnTo: null,
    draft: null,
    pendingFile: null,

    startCapture: ({ returnTo, draft }) =>
      set({
        isCapturing: true,
        returnTo,
        draft: draft ?? null,
        pendingFile: null,
      }),

    // Taslak korunur: kullanıcı vazgeçse de yazdıklarını kaybetmemeli
    cancelCapture: () => set({ isCapturing: false, pendingFile: null }),

    finishCapture: (file) => set({ isCapturing: false, pendingFile: file }),

    consumeCapture: () => {
      const { pendingFile, draft } = get();
      if (!pendingFile) return null;
      set({ pendingFile: null, draft: null, returnTo: null });
      return { file: pendingFile, draft };
    },
  }),
);
